<script setup lang="ts">
import { useI18n } from '@/plugins/i18n'
import { useSearchStore } from '../../store/index.ts'
import { COLLECTIONS_SEARCH_TAB, COLLECTIONS_FILTER_KEYS } from '@/components/Search/constants.ts';
import { ref, computed } from 'vue';
import AllFiltersModal from '@/components/Search/SearchBar/AllFiltersModal/index.ce.vue';
import { useSearchActions } from '@/components/Search/SearchResults/Composables/useSearchActions.ts'

//props
const props = defineProps({
    forMobile: { type: Boolean, default: false }
})
const displayAllFiltersMobile = ref(false);
const searchStore = useSearchStore()
const { getItem } = searchStore

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance


const { 
  clearAllFilters,
  clearAllSearchBarFilters
} = useSearchActions(COLLECTIONS_SEARCH_TAB, COLLECTIONS_FILTER_KEYS)

const handleShowFilterMoreOptions = () => {
    searchStore[`${COLLECTIONS_SEARCH_TAB}.displayMoreSearchBarFilters`] = !searchStore[`${COLLECTIONS_SEARCH_TAB}.displayMoreSearchBarFilters`];
    if(!searchStore[`${COLLECTIONS_SEARCH_TAB}.displayMoreSearchBarFilters`]) {
        searchStore.clearSearchBarFilters(COLLECTIONS_SEARCH_TAB, ['documentNumber']);
    }
}

const handleSearch = () => {
  searchStore.searchCollections(searchStore['searchResultActive']);
  displayAllFiltersMobile.value = false;
}
const handleClearAllFilters = () => {
    if(searchStore['searchResultActive']) {
        clearAllFilters();
    } else {
        clearAllSearchBarFilters();
    }
}
const placeholderText = computed(() => props.forMobile ? t('searchByDocNumberForMobie') : t('searchByDocNumber'));
</script>

<template>
    <div class="search-input-area">
        <div class="search-input-main">
            <div class="search-input">
                <input type="text" id="query1" name="query1" :placeholder="placeholderText" v-model="searchStore[`${COLLECTIONS_SEARCH_TAB}.documentNumber`] "  @keyup.enter="searchStore.searchCollections(false)" autocomplete="off"/>
            </div>
            <div class="search-clear">
                <img src="@/assets/img/icon-search-clear.svg" @click="searchStore[`${COLLECTIONS_SEARCH_TAB}.documentNumber`] = ''"/>
            </div>
        </div>
        <div  v-if="!forMobile" class="search-filter">
            <div :class="['btn-search-filter', { active: getItem(`${COLLECTIONS_SEARCH_TAB}.displayMoreSearchBarFilters`) }]" @click="handleShowFilterMoreOptions">{{ t('filters') }}</div>
        </div>
        <div  v-if="forMobile" class="search-filter">
            <div :class="['btn-search-filter-mobile']" @click="displayAllFiltersMobile=true"></div>
            <AllFiltersModal :display="displayAllFiltersMobile" @closeModal="displayAllFiltersMobile=false" :forMobile="true" @handleSearch="handleSearch"  @clearAll="handleClearAllFilters"></AllFiltersModal>
        </div>
    </div>
</template>